/* tslint:disable */
/* eslint-disable */
/**
 * MAPIIO API
 * API mapové aplikace Mapiio pro klientskou JavaScriptovou / React část.
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { GeoJsonObject } from '../model';
// @ts-ignore
import { SplitPolygonsRequestVO } from '../model';
// @ts-ignore
import * as Objs from './index'
// @ts-ignore
import { DataResponseVO, DataRequestVO, ExportRequestVO } from '@mc/data-filter-react';

/**
 * GeometryControllerApi - axios parameter creator
 * @export
 */
export const GeometryControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Splits a polygon geometry with a line
         * @param {SplitPolygonsRequestVO} splitPolygonsRequestVO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        splitPolygons: async (splitPolygonsRequestVO: SplitPolygonsRequestVO, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'splitPolygonsRequestVO' is not null or undefined
            assertParamExists('splitPolygons', 'splitPolygonsRequestVO', splitPolygonsRequestVO)
            const localVarPath = `/api/geometry/polygon-split`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(splitPolygonsRequestVO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GeometryControllerApi - functional programming interface
 * @export
 */
export const GeometryControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GeometryControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Splits a polygon geometry with a line
         * @param {SplitPolygonsRequestVO} splitPolygonsRequestVO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async splitPolygons(splitPolygonsRequestVO: SplitPolygonsRequestVO, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Array<GeoJsonObject>>>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.splitPolygons(splitPolygonsRequestVO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * GeometryControllerApi - factory interface
 * @export
 */
export const GeometryControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GeometryControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary Splits a polygon geometry with a line
         * @param {SplitPolygonsRequestVO} splitPolygonsRequestVO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        splitPolygons(splitPolygonsRequestVO: SplitPolygonsRequestVO, options?: any): AxiosPromise<Array<Array<GeoJsonObject>>> {
            return localVarFp.splitPolygons(splitPolygonsRequestVO, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GeometryControllerApi - interface
 * @export
 * @interface GeometryControllerApi
 */
export interface GeometryControllerApiInterface {
    /**
     * 
     * @summary Splits a polygon geometry with a line
     * @param {SplitPolygonsRequestVO} splitPolygonsRequestVO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeometryControllerApiInterface
     */
    splitPolygons(splitPolygonsRequestVO: SplitPolygonsRequestVO, options?: any): AxiosPromise<Array<Array<GeoJsonObject>>>;

}

/**
 * GeometryControllerApi - object-oriented interface
 * @export
 * @class GeometryControllerApi
 * @extends {BaseAPI}
 */
export class GeometryControllerApi extends BaseAPI implements GeometryControllerApiInterface {
    /**
     * 
     * @summary Splits a polygon geometry with a line
     * @param {SplitPolygonsRequestVO} splitPolygonsRequestVO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeometryControllerApi
     */
    public splitPolygons(splitPolygonsRequestVO: SplitPolygonsRequestVO, options?: any) {
        return GeometryControllerApiFp(this.configuration).splitPolygons(splitPolygonsRequestVO, options).then((request) => request(this.axios, this.basePath));
    }
}
